import DealerInterface from '../interfaces/dealer.interface';
import DealerBadgeInterface from '../interfaces/dealer-badge.interface';

export default function dealerDestructure(dealer: DealerInterface): {[index: string]: DealerBadgeInterface;} {
    const maps: {[index: string]: string;} = {
        badge_free_delivery: 'freeDelivery',
        highlight: 'highlighted',
        in_post: 'inPost',
        badge_delivery_24h: 'delivery24h',
        badge_rates: 'rates',
        badge_fast_payments: 'fastPayment',
        promoText: 'promoText'
    };

    return (dealer.badges.reduce(
        (acc, item) => {
            if (maps[item.type]) {
                acc[maps[item.type as string]] = item;
            }

            return acc as {[index: string]: DealerBadgeInterface;};
        }, {} as Record<string, DealerBadgeInterface>
    ));
}
